import React from "react";
import { Pie } from "react-chartjs-2";
import { Chart as ChartJS, ArcElement, Tooltip, Legend } from "chart.js";

ChartJS.register(ArcElement, Tooltip, Legend);

export default function PaymentStatusPieChart({ data }) {
  const pending = data.find(d => d.status === "pending")?.count || 0;
  const successful = data.find(d => d.status === "successful")?.count || 0;
  const cancelled = data.find(d => d.status === "cancelled")?.count || 0;

  const total = pending + successful + cancelled;

  const chartData = {
    labels: ["Pending", "Successful", "Cancelled"],
    datasets: [
      {
        label: "Payment Status",
        data: [pending, successful, cancelled],
        backgroundColor: ["#ffa700", "#4caf50", "#f44336"],
      },
    ],
  };

  return (
    <div className="chartCard pieChart">
      <h3>Payment Status Distribution</h3>
      <div className="pieChartContainer">
        {total > 0 ? (
          <Pie data={chartData} />
        ) : (
          <p style={{ textAlign: "center", color: "#666" }}>
            No payment data available
          </p>
        )}
      </div>
    </div>
  );
}
